import { render, staticRenderFns } from "./BOpenDataFullDB.vue?vue&type=template&id=02d11607&scoped=true"
import script from "./BOpenDataFullDB.vue?vue&type=script&lang=js"
export * from "./BOpenDataFullDB.vue?vue&type=script&lang=js"
import style0 from "./BOpenDataFullDB.vue?vue&type=style&index=0&id=02d11607&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d11607",
  null
  
)

export default component.exports